import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import {
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Stack,
  Typography,
} from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";

export default function ProductsSection() {
  const navigate = useNavigate();
  const handleViewProductsClick = () => {
    navigate("/acs-products-showcase"); // Replace with your actual route
  };

  // Product data for mapping
  const products = [
    // {
    //   id: 1,
    //   title: "Metal Cards",
    //   description:
    //     "Golden, Silver, and Black premium Metal Apna Cards enhance your brand's appeal with durability, luxury, and advanced NFC for secure, efficient data sharing.",
    //   image: "https://via.placeholder.com/168",
    //   size: "small",
    // },
    // {
    //   id: 2,
    //   title: "Personalized Branding",
    //   description:
    //     "Incorporate company logos, colors, and designs unique to the user or business. Custom designs for specific industries, such as health care, education, or transportation.",
    //   image: "https://via.placeholder.com/218",
    //   size: "large",
    // },
    {
      id: 3,
      title: "Digital Cards",
      description:
        "A simple NFC plastic card combines the basic functionality of a plastic card with the advanced technology of Near Field Communication (NFC).",
      image: "https://via.placeholder.com/168",
      size: "large",
    },
  ];

  return (
    <Box
      component="section"
      sx={{
        bgcolor: "#1f164f",
        py: { xs: 6, md: 8 },
        px: { xs: 2, md: 12.5 },
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: { xs: 4, md: 6.25 },
      }}
    >
      <Typography
        variant="h1"
        sx={{
          color: "white",
          fontSize: { xs: "36px", sm: "48px", md: "64px" },
          textAlign: "center",
          fontWeight: 700,
          letterSpacing: { xs: "-2px", md: "-5px" },
          fontFamily: "'Jost-Bold', Montserrat",
          px: { xs: 2, md: 0 },
        }}
      >
        OUR PRODUCTS
      </Typography>

      <Container maxWidth="xl" sx={{ px: { xs: 0, sm: 2 } }}>
        <Stack
          direction={{ xs: "column", md: "row" }}
          spacing={{ xs: 4, md: 8, lg: 15 }}
          justifyContent={{ xs: "stretch", md: "center" }}
          alignItems="center"
          sx={{ width: "100%" }}
        >
          {products.map((product) => (
            <Box
              key={product.id}
              sx={{
                width: {
                  xs: "100%",
                  sm: "85%",
                  md: product.size === "large" ? 380 : 300,
                },
                maxWidth: { xs: "420px", md: "none" },
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                textAlign: "center",
              }}
            >
              <Box
                component="img"
                src={"/websiteAssets/LandingPageProductImage.png"}
                alt="Product"
                sx={{
                  width: {
                    xs: product.size === "large" ? 150 : 120,
                    sm: product.size === "large" ? 180 : 140,
                    md: product.size === "large" ? 218 : 168,
                  },
                  height: {
                    xs: product.size === "large" ? 150 : 120,
                    sm: product.size === "large" ? 180 : 140,
                    md: product.size === "large" ? 218 : 168,
                  },
                  objectFit: "cover",
                  mb: { xs: -5, md: -7 },
                  zIndex: 1,
                }}
              />
              <Card
                sx={{
                  width: "100%",
                  maxWidth: {
                    xs: "100%",
                    md: product.size === "large" ? 400 : 300,
                  },
                  height: {
                    xs: product.size === "large" ? 280 : 220,
                    sm: product.size === "large" ? 320 : 240,
                    md: product.size === "large" ? 350 : 250,
                  },
                  borderRadius: "25px",
                  boxShadow: "2px 2px 4px 5px rgba(217,217,217,0.35)",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <CardContent
                  sx={{
                    textAlign: "center",
                    px: { xs: 2, md: product.size === "large" ? 4.75 : 3.25 },
                    mt: {
                      xs: product.size === "large" ? 6 : 5,
                      md: product.size === "large" ? 8 : 6,
                    },
                  }}
                >
                  <Typography
                    variant="h5"
                    sx={{
                      fontFamily: "'Istok_Web-Bold', Montserrat",
                      fontWeight: 700,
                      fontSize: {
                        xs: product.size === "large" ? 20 : 18,
                        sm: product.size === "large" ? 24 : 20,
                        md: product.size === "large" ? 32 : 24,
                      },
                      mb: { xs: 1, md: product.size === "large" ? 2 : 1.5 },
                    }}
                  >
                    {product.title}
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: "'Satoshi-Medium', Montserrat",
                      fontWeight: 500,
                      color: "rgba(97, 97, 97, 0.75)",
                      fontSize: {
                        xs: product.size === "large" ? 14 : 12,
                        sm: product.size === "large" ? 16 : 14,
                        md: product.size === "large" ? 20 : 15,
                      },
                    }}
                  >
                    {product.description}
                  </Typography>
                </CardContent>
              </Card>
            </Box>
          ))}
        </Stack>
      </Container>

      <Button
        onClick={handleViewProductsClick}
        variant="contained"
        endIcon={<ArrowForwardIcon />}
        sx={{
          bgcolor: "white",
          color: "#1f164f",
          borderRadius: "10px",
          width: { xs: "90%", sm: 250 },
          maxWidth: 250,
          height: { xs: 50, md: 55 },
          textTransform: "none",
          fontFamily: "'Istok_Web-Bold', Montserrat",
          fontWeight: 700,
          fontSize: { xs: 14, md: 16 },
          "&:hover": {
            bgcolor: "white",
          },
        }}
      >
        View All Products
      </Button>
    </Box>
  );
}
